import React, { useEffect, useState, useRef } from "react";
import { RiDeleteBin6Fill } from "react-icons/ri";
import "./UploadComputer.css";
import { Input, Button, Form, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { workspaces_List_ActionHandler } from "../../../../../Redux/Actions/user/WorkspacesList";
import { workspaces_FolderList_ActionHandler } from "../../../../../Redux/Actions/user/WorkspaceFolderList";
import { SupportingDocumentsFileUploadActionHandler } from "../../../../../Redux/Actions/user/BuildQuickFileUploadAction";
import {
  CreateSupportingDocumentsActionHandler,
  clearDocumentsSupportingData,
} from "../../../../../Redux/Actions/user/BuildQuickCreateSupportingDocumentsAction";
import { workspaces_Support_Documents_ActionHandler } from "../../../../../Redux/Actions/user/WorkspaceSupportingDocumentList";
const { Option } = Select;

const UploadComputer = ({
  workspaceFolderFlag,
  workspace_id,
  folder_id,
  name,
  context,
  handleCreateSupportDocument,
  handleSupportingDocumentButtonClick,
  DragDropFile,
  setDragDropFile,
  isUploadComputer,
  workspaceId_uc,
  workspaceFolderId,
  workspaceByIdStatus,
}) => {
  let dispatch = useDispatch();
  const [form] = Form.useForm();
  const fileInputRef = React.createRef();
  const [workspaceId, setWorkspaceId] = useState(null);
  const [folderId, setFolderId] = useState(workspaceFolderId);
  const supportingdocumentsfileuploaddata = useSelector(
    (state) =>
      state?.BuildQuickFileUploadData?.supporting_documents_file_upload_data
  );
  const documentssupportingcreatedata = useSelector(
    (state) =>
      state?.BuildQuickCreateSupportingDocumentsData
        ?.documents_supporting_create_data
  );
  const workspaceData = useSelector(
    (state) => state?.workspaces_List_Data?.workspace_create_data?.data
  );
  const workspaceFolderListData = useSelector(
    (state) =>
      state?.workspaces_Supporting_Document_FolderList_Data
        ?.workspace_supporting_documentlist_data?.data
  );
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadFileName, setUploadFileName] = useState(
    supportingdocumentsfileuploaddata?.data?.filename
  );
  const [wordCount, setWordCount] = useState(
    supportingdocumentsfileuploaddata?.data?.word_count
  );
  const [content, setContent] = useState(
    supportingdocumentsfileuploaddata?.data?.content
  );
  const [loader, setLoader] = useState(false);
  const formRef = React.createRef();

  //DRAG DROP
  useEffect(() => {
    if (DragDropFile && DragDropFile[0]?.name) {
      setUploadedFile(null);
      const allowedFileTypes = [
        "application/pdf",
        "audio/mpeg",
        "video/mp4",
        "audio/mp3",
        "text/plain",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/doc",
        "application/docx",
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/tiff",
        "image/bmp",
        "image/heif",
      ];

      if (
        DragDropFile[0].type &&
        allowedFileTypes.includes(DragDropFile[0].type)
      ) {
        const fileName = DragDropFile[0];
        setUploadedFile(fileName);
        dispatch(SupportingDocumentsFileUploadActionHandler(DragDropFile[0]));
      }
    }
  }, [DragDropFile]);
  //DRAG DROP

  const handleFileChange = (event) => {
    setLoader(true);
    const file = event.target.files[0];
    const allowedFileExtensions =
      /\.(pdf|mp3|mp4|txt|doc|docx|jpg|jpeg|png|tiff|bmp|heif)$/i;
    if (file && allowedFileExtensions.test(file.name)) {
      dispatch(SupportingDocumentsFileUploadActionHandler(file));
      setUploadedFile(file);
      // setTimeout(() => {

      // }, 2000);
    } else {
      alert("Please select a valid PDF, MP3, or MP4 file.");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setUploadFileName(null);
      setWordCount(null);
      setContent(null);
      setLoader(false);
    }
  };

  const handleDeleteClick = () => {
    setUploadedFile(null);
    setUploadFileName(null);
    setWordCount(null);
    setContent(null);
  };

  const handleDivClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // useEffect(() => {
  //   if (workspaceFolderListData) {
  //     setFolderId(workspaceFolderId);
  //   }
  // }, [workspaceFolderListData]);

  const handleDrop = (e) => {
    e.preventDefault();
    setLoader(true);
    const file = e.dataTransfer.files[0];
    if (file) {
      const allowedFileTypes = [
        "application/pdf",
        "audio/mpeg",
        "video/mp4",
        "audio/mp3",
        "text/plain",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/doc",
        "application/docx",
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/tiff",
        "image/bmp",
        "image/heif",
      ];
      if (file && allowedFileTypes.includes(file.type)) {
        dispatch(SupportingDocumentsFileUploadActionHandler(file));
        setUploadedFile(file);
        setTimeout(() => {
          setLoader(false);
        }, 2000);
      } else {
        alert("Please select a valid PDF, MP3, or MP4 file.");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setUploadFileName(null);
        setWordCount(null);
        setContent(null);
        setLoader(false);
      }
    } else {
      console.error("No file found in dataTransfer.");
      setLoader(false);
    }
  };

  useEffect(() => {
    dispatch(workspaces_List_ActionHandler("", ""));
    setUploadFileName(supportingdocumentsfileuploaddata?.data?.filename);
    setWordCount(supportingdocumentsfileuploaddata?.data?.word_count);
    setContent(supportingdocumentsfileuploaddata?.data?.content);
    if (supportingdocumentsfileuploaddata?.data?.filename) {
      setLoader(false);
    }
  }, [supportingdocumentsfileuploaddata]);

  useEffect(() => {
    if (workspaceId) {
      dispatch(workspaces_Support_Documents_ActionHandler(workspaceId, "", ""));
    }
  }, [workspaceId]);

  useEffect(() => {
    if (workspaceId_uc || workspaceByIdStatus) {
      dispatch(
        workspaces_Support_Documents_ActionHandler(
          workspaceId_uc || workspaceByIdStatus,
          "",
          ""
        )
      );
    }
  }, [workspaceId_uc, workspaceByIdStatus]);

  useEffect(() => {
    setContent("");
  }, []);
  // useEffect(() => {
  //   if (documentssupportingcreatedata) {
  //     handleCreateSupportDocument(false);
  //     handleSupportingDocumentButtonClick(false);
  //     dispatch(clearDocumentsSupportingData());
  //   }
  // }, [documentssupportingcreatedata, dispatch]);

  const handleChangeWorkspace = (value) => {
    formRef.current.resetFields(["folder_id"]);
    setFolderId("");
    setWorkspaceId(value);
  };

  const [uploadInitiated, setUploadInitiated] = useState(false);
  useEffect(() => {
    if (isUploadComputer && !uploadInitiated && !DragDropFile) {
      fileInputRef.current.click();
      setUploadInitiated(true);
      setUploadFileName(null);
    }
  }, []);

  const onFinish = (values) => {
    if (workspace_id || workspaceByIdStatus) {
      workspace_id = workspace_id || workspaceByIdStatus;
    } else {
      workspace_id = values.workspace_id;
    }
    if (folder_id) {
      folder_id = folder_id;
    } else {
      folder_id = values.folder_id;
    }
    const submitObject = {
      workspace_id: parseInt(workspace_id, 10),
      folder_id: folder_id,
      name: values.name,
      context: "This is the " + values.name + ":",
      type: "file",
      files: [
        {
          id: supportingdocumentsfileuploaddata?.data?.id,
          content: supportingdocumentsfileuploaddata?.data?.content,
        },
      ],
    };

    dispatch(CreateSupportingDocumentsActionHandler(submitObject));
    setTimeout(() => {
      handleCreateSupportDocument(false);
      handleSupportingDocumentButtonClick(false);
    }, 2000);
  };

  const handleFormChange = (changedFields, allFields) => {
    const changedField = changedFields[0];

    if (changedField) {
      const fieldName = Array.isArray(changedField.name)
        ? changedField.name[0]
        : changedField.name;
      if (fieldName === "name") {
        formRef.current.setFieldsValue({
          ["context"]: "This is the " + changedField.value + ":",
        });
      }
    }
  };
  let htmlContent = content;

  if (htmlContent != undefined) {
    htmlContent = htmlContent.replace(/\n/g, "<br>");
  }

  let formattedHtml = (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
  );
  if (typeof formattedHtml == "string") {
    formattedHtml = formattedHtml?.split("\n").map((str) => <p>{str}</p>);
  }

  useEffect(() => {
    if (uploadedFile) {
      formRef.current.setFieldsValue({
        name: `${name} ${uploadedFile?.name?.replace(/\.[^.]+$/, "")}`,
      });
    }
  }, [uploadedFile]);

  return (
    <>
      {loader ? (
        <>
          <div
            className="loader-workspace"
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              zIndex: 1,
              width: "120px",
              height: "120px",
              margin: "-76px 0 0 -76px",
              border: "16px solid #f3f3f3",
              borderRadius: "50%",
              borderTop: "16px solid #3498db",
              WebkitAnimation: "spin 2s linear infinite",
              animation: "spin 2s linear infinite",
            }}
          ></div>
        </>
      ) : null}
      <Form
        name="uploadComputerForm"
        initialValues={{
          name: name,
          context: "This is the " + name + ":",
          workspace_id: workspaceId_uc,
          folder_id: "",
        }}
        onFieldsChange={handleFormChange}
        onFinish={onFinish}
        ref={formRef}
        style={{ opacity: loader ? 0.5 : null }}
      >
        <div className="supporting-document-1">
          <label>Supporting document name</label>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: "Please input your name!",
              },
              {
                type: "name",
                message: "Please enter a valid name",
              },
            ]}
          >
            <Input placeholder="Enter your name" />
          </Form.Item>
        </div>
        {/* <div className="supporting-document-2">
          <label>Context to frame reference data (edit if required)</label>
          <Form.Item
            name="context"
            rules={[
              {
                required: true,
                message: "Please input your context!",
              },
              {
                type: "context",
                message: "Please enter a valid context",
              },
            ]}
          >
            <Input placeholder="Enter your context" />
          </Form.Item>
        </div> */}
        <div className="upload-computer-2">
          <label>Reference data</label>
          <div
            className="upload-computer-img-height-320"
            onClick={handleDivClick}
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
          >
            <div className="upload-computer-main-div">
              <div className="upload-computer-span">
                {uploadedFile ? (
                  <>
                    <div className="upload-computer-middle-div-first-p">
                      {uploadFileName}
                      <RiDeleteBin6Fill
                        className="upload-computer-delete-svg"
                        onClick={handleDeleteClick}
                      />
                    </div>
                    <div className="upload-computer-middle-div-second-p">
                      Word Count: {wordCount?.toLocaleString()}
                    </div>
                  </>
                ) : (
                  <div className="upload-computer-middle-div-first-p">
                    Click to Upload
                  </div>
                )}
              </div>
            </div>
            <input
              type="file"
              ref={fileInputRef}
              className="file-none"
              onChange={handleFileChange}
              onClick={(e) => {
                e.stopPropagation();
              }}
              accept=".pdf, .mp3, .mp4, .txt, .doc, .docx, application/pdf, audio/mp3, video/mp4, text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png, image/jpg, image/tiff, image/bmp, image/heif"
            />
          </div>
          <div className="upload-computer-main-content">
            <p>{formattedHtml}</p>
          </div>
          {workspaceFolderFlag ? null : (
            <>
              <div className="upload-computer-modal-div">
                <h3>Select Destination Directory</h3>
              </div>

              <div className="upload-computer-input">
                {!workspaceByIdStatus && (
                  <div className="upload-computer-1">
                    <label>Select Workspace</label>
                    <Form.Item
                      name="workspace_id"
                      rules={[
                        {
                          required: true,
                          message: "Please select a workspace!",
                        },
                      ]}
                    >
                      <Select
                        className="uploadcomputer-select"
                        onChange={handleChangeWorkspace}
                      >
                        {workspaceData &&
                          workspaceData?.map((workspace) => (
                            <>
                              {!workspace?.is_locked && (
                                <Option
                                  key={workspace?.id}
                                  value={workspace?.id}
                                >
                                  {workspace?.name}
                                </Option>
                              )}
                            </>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}
                <div className="upload-computer-2">
                  <label>Select Folder</label>
                  <Form.Item
                    name="folder_id"
                    rules={[
                      {
                        required: true,
                        message: "Please select a folder!",
                      },
                    ]}
                  >
                    <Select className="uploadcomputer-select" name="folder_id">
                      {workspaceFolderListData &&
                        workspaceFolderListData?.map((folder) => (
                          <Option key={folder.id} value={folder?.id}>
                            {folder?.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </>
          )}
          <div className="upload-computer-supporting-div">
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                className="upload-computer-supporting-button"
              >
                Create Supporting Document
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </>
  );
};
export default UploadComputer;
